import { SET_TIMELINE_DATES } from '../../constants/appTypes';
import { IDateRangeObject } from '../../types/timeline';
import moment from 'moment';

const initialState: IDateRangeObject = {
  startDate: moment().subtract(1, 'year'),
  endDate: moment(),
};

interface timelineDatesAction {
  dates: IDateRangeObject;
  type: string;
}

export function timelineDateRange(state = initialState, action: timelineDatesAction) {
  switch (action.type) {
    case SET_TIMELINE_DATES:
      state = { ...action.dates };
      return state;
    default:
      return state;
  }
}

export default timelineDateRange;
